// vue
import { ref } from 'vue';

// WsOrders
import WsOrders from '@services/trade-statistic/ws-orders';

// coockie
import { useCookies } from 'vue3-cookies';

// interfaces
interface IConnect {
  botId: number | string;
  cycleId: number;
  callBack?: Function;
}

export const useWsOrders = () => {
    // vars
    const ws = ref<WsOrders | null>();

    const useConnect = ({ botId, cycleId, callBack }: IConnect) => {
        if (ws.value?.isConnected()) return;

        // coockies
        const { cookies } = useCookies();
        const rbSession = cookies.get('rb_session');
    
        // ws connect
        ws.value = new WsOrders(rbSession, botId, cycleId);
        ws.value.connect();
    
        if (callBack) {
            ws.value.addListener($event => callBack($event));
        }
    };

    const useDisconnect = () => {
        ws.value?.disconnect();
    };

    return {
        useConnect,
        useDisconnect,
    };
};